import React from 'react'
import { useTranslation } from 'react-i18next'
import { BulbOutlined } from '@ant-design/icons'
import { useGlobalThemeStore } from 'store/globalThemeStore/globalThemeStore'
import { ThemeModes } from 'theme/theme'

import IconButtonWithTooltip from '../IconButtonWithTooltip/IconButtonWithTooltip'

import { StyledButtonContainer } from './ChangePageContrastButton.style'

const ChangePageContrastButton = () => {
    const [{ globalTheme }, { setTheme }] = useGlobalThemeStore()
    const { t } = useTranslation()

    const handleToggleTheme = (mode: ThemeModes) =>
        mode === ThemeModes.LIGHT
            ? setTheme(ThemeModes.HIGH_CONTRAST)
            : setTheme(ThemeModes.LIGHT)

    return (
        <StyledButtonContainer>
            <li>
                <IconButtonWithTooltip
                    t={t('high_contrast')}
                    icon={<BulbOutlined />}
                    onClick={() => handleToggleTheme(globalTheme.mode)}
                />
            </li>
        </StyledButtonContainer>
    )
}

export default ChangePageContrastButton
